// extracted by mini-css-extract-plugin
export default {"ClientLogo":"styles_ClientLogo__hv4ua","SiteLogoCon":"styles_SiteLogoCon__8zs7o","NavContainer":"styles_NavContainer__8QvuR","NavClientLogoCon":"styles_NavClientLogoCon__LRRR-"};